/**
 * Load pdf.js's core library in the browser, with its worker wired.
 *
 * Shared by `DocumentPreview` (which layers pdf.js's viewer on top) and the
 * trust statement review (which renders pages to its own canvases so it can
 * draw over them). Both reasons it is written this way are documented at the
 * `DocumentPreview` call site and guarded by
 * `__tests__/pdfjs-legacy-build-polyfill.test.ts`:
 *
 * - the `legacy/` build, because only it carries the polyfill pdf.js 6 needs;
 * - the worker served from `public/`, because the bundler cannot resolve the
 *   package's own worker import.
 *
 * Imported dynamically: pdf.js is ~1MB and touches browser-only APIs.
 */
export async function loadPdfjs() {
  const pdfjs = await import('pdfjs-dist/legacy/build/pdf.mjs');
  pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
  return pdfjs;
}
